<template>
  <div>
  <b-row>
    <b-col>
      <div class="mb-1 float-right" v-if="ableToCreatePromotion">
        <button type="button" class="btn btn-sm btn-primary" @click="toggleCreateModal()">
          {{$t('buttons.create')}}
        </button>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <b-card>
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div v-else-if="!isLoading && items.length < 1" >
          {{ $t('views.promotions.list.noPromotions') }}
        </div>
        <table class="table table-sm table-striped table-hover text-center" v-else>
          <thead>
          <tr>
            <th>{{ $t('views.promotions.form.state') }}</th>
            <th>{{ $t('views.promotions.form.canjoin') }}</th>
            <th>{{ $t('views.promotions.form.title') }}</th>
            <th>{{ $t('views.promotions.form.value') }}</th>
            <th>{{ $t('views.promotions.form.type') }}</th>
<!--            <th>{{ $t('views.promotions.form.dateFrom') }}</th>-->
<!--            <th>{{ $t('views.promotions.form.dateTo') }}</th>-->
            <th>{{ $t('buttons.options') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>
              <i :class="getIcon(item.state).icon" :style="'color: ' + getIcon(item.state).color" v-b-tooltip.hover :title="getIcon(item.state).toolTip"></i>
            </td>
            <td>
              <i :class="getIcon(item.canjoin).icon" :style="'color: ' + getIcon(item.canjoin).color" v-b-tooltip.hover :title="getIcon(item.canjoin).toolTip"></i>
            </td>
            <td>{{ item.title }}</td>
            <td>{{ item.value }}</td>
            <td>
              <span v-if="item.type === 0">{{$t("views.promotions.form.amountvalue")}}</span>
              <span v-if="item.type === 1">{{$t("views.promotions.form.percentvalue")}}</span>
              <span v-if="item.type === 2">{{$t("views.promotions.form.special")}}</span>
            </td>
<!--            <td><span v-if="item.dateFrom">{{ $moment(item.dateFrom).format('YYYY-MM-DD HH:mm') }}</span></td>-->
<!--            <td><span v-if="item.dateTo">{{ $moment(item.dateTo).format('YYYY-MM-DD HH:mm') }}</span></td>-->
            <td>
              <button v-if="ableToUpdatePromotion" class="btn btn-link fa fa-edit fa-lg" v-b-tooltip.hover :title="$t('buttons.edit')" @click="showEditModal(item['@id'])"></button>
            </td>
          </tr>
          </tbody>
        </table>
      </b-card>
    </b-col>
  </b-row>
    <CreateModal></CreateModal>
    <UpdateModal v-if="promotionIri && isUpdateModalVisible" :iri="promotionIri"></UpdateModal>
  </div>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import CreateModal from '@/components/Dashboard/Views/AgreementsBundle/promotions/CreateModal'
import UpdateModal from '@/components/Dashboard/Views/AgreementsBundle/promotions/UpdateModal'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'

export default {
  name: 'PromotionsList',
  components: {
    UpdateModal,
    Loader,
    CreateModal
  },
  data () {
    return {
      promotionIri: null
    }
  },
  watch: {
    created () {
      this.fetchPromotions()
    },
    updated () {
      this.fetchPromotions()
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'promotions/getIsLoadingPromotions',
      items: 'promotions/getPromotions',
      view: 'promotions/getPromotionsView',
      created: 'promotions/getCreated',
      updated: 'promotions/getUpdated',
      isUpdateModalVisible: 'promotions/getIsUpdateModalVisible'
    }),
    ableToCreatePromotion () {
      return checkPermission('exabagreements', 'EXABPromotionsCreate')
    },
    ableToUpdatePromotion () {
      return checkPermission('exabagreements', 'EXABPromotionsUpdate')
    }
  },
  created () {
    this.fetchPromotions()
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABPromotionsList')
  },
  methods: {
    getIcon (num) {
      if (num === 1) {
        return { icon: 'fa fa-check-circle fa-lg', color: '#28a745', toolTip: this.$t('buttons.yes') }
      } else {
        return { icon: 'fa fa-times-circle fa-lg', color: '#dc3545', toolTip: this.$t('buttons.no') }
      }
    },
    ...mapMutations({
      toggleCreateModal: 'promotions/toggleCreateModal',
      toggleUpdateModal: 'promotions/toggleUpdateModal'
    }),
    ...mapActions({
      fetchPromotions: 'promotions/fetchPromotions'
    }),
    showEditModal (iri) {
      this.promotionIri = iri
      this.toggleUpdateModal()
    }
  }
}
</script>

<style scoped>

</style>
